import { apiClient } from "../../base/ApiClient";

// --- Locations APIs ---
export const createLocations = async (data) => {
  const response = await apiClient.post(`/core/location/`, data);
  return response.data;
};

export const getAllLocations = async () => {
  const response = await apiClient.get(`/core/location/`);
  return response.data;
};

// --- Care Plan APIs ---
export const createCarePlan = async (data) => {
  const response = await apiClient.post(`/core/care-plans/`, data);
  return response.data;
};

export const getAllCarePlan = async () => {
  const response = await apiClient.get(`/core/care-plans/`);
  return response.data;
};

// --- Checklist & Instructions APIs ---
export const createChecklist = async (data) => {
  const response = await apiClient.post(`/core/checklists/`, data);
  return response.data;
};

export const getAllChecklist = async () => {
  const response = await apiClient.get(`/core/checklists/`);
  return response.data;
};

export const getChecklistByID = async (ID) => {
  const response = await apiClient.get(`/core/checklists/${ID}/`);
  return response.data;
};

export const getChecklistItemsNested = async (ID) => {
  const response = await apiClient.get(`/core/checklists/${ID}/items/`);
  return response.data;
};

export const updateChecklist = async (ID, data) => {
  const response = await apiClient.put(`/core/checklists/${ID}/`, data);
  return response.data;
};

export const deleteChecklistByID = async (ID) => {
  const response = await apiClient.delete(`/core/checklists/${ID}/`);
  return response.data;
};

// --- Sub-locations & Schedules ---
export const createSubLocations = async (data) => {
  const response = await apiClient.post(`/schedule/sublocations/`, data);
  return response.data;
};

export const getWeeklyScheduleLogs = async (page) => {
  const response = await apiClient.get(`/core/weekly_script_logs/?page=${page}`);
  return response.data;
};

// --- Location Managers Assignment ---
export const getManagersByLocation = async (locationId) => {
  const response = await apiClient.get(`/core/assign-manager/?location=${locationId}`);
  return response.data;
};

export const assignManager = async (data) => {
  const response = await apiClient.post(`/core/assign-manager/`, data);
  return response.data;
};

export const updateManagerAssignment = async (id, data) => {
  const response = await apiClient.patch(`/core/assign-manager/${id}/`, data);
  return response.data;
};

export const removeManagerAssignment = async (id) => {
  const response = await apiClient.delete(`/core/assign-manager/${id}/`);
  return response.data;
};